<form (ngSubmit)="deleteFacebookFundraiser()" #f="ngForm" id="facebookDeletionForm" class="facebook-confirmation-modal">

  <div class="modal-body pt-md-5 pb-md-5">
    <div class="form-group row mb-0 pt-2 pb-2">
      The Facebook Fundraiser linked to your account has been deleted through Facebook. Please click OK to continue to access your LLS account and create a new Facebook Fundraiser.
    </div>
  </div>
  <div class="modal-footer">
    <button form="facebookDeletionForm" class="btn btn-primary">Ok</button>
  </div>
</form>